import { createAsyncThunk } from "@reduxjs/toolkit";
import getApiUrl from "../../../api";

const asyncCurrentUser = createAsyncThunk(
    'user/current',
    async function() {
        const accessToken = sessionStorage.access;
        const promise = await fetch(getApiUrl() + '/api/user/current', {
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        });
        const json = await promise.json();
        return json;
    },
)

export default asyncCurrentUser;